import React, { useMemo } from 'react';
import Icon from 'utils/components/icon';
import { useTracking } from 'react-tracking';
import { IPageInfo, Folder, ActionButton, ActionSource } from '../../../state/types';

export interface Props {
  buttons: ActionButton[];
  numberOfCheckedItems: number;
  pageInfo: IPageInfo;
  numberOfItems: number;
  counts: { [folder in Folder]: number };
  selectAllItems: () => void;
  clearAllItems: () => void;
  onOpenModal: (type: ActionButton, source: ActionSource) => void;
}

const MultiSelect: React.FC<Props> = ({
  buttons = [],
  numberOfCheckedItems,
  pageInfo,
  numberOfItems,
  counts,
  selectAllItems,
  clearAllItems,
  onOpenModal
}) => {
  const tracking = useTracking();

  const clearAll = () => {
    tracking.trackEvent({ eventName: 'bulk clear all' });
    clearAllItems();
  };

  const selectAll = () => {
    tracking.trackEvent({ eventName: 'bulk select all' });
    selectAllItems();
  };

  const openConfirmModal = (type: ActionButton) => {
    onOpenModal(type, 'mouse');
  };

  const actionButtons = useMemo(() => {
    return buttons.map((button: ActionButton) => {
      const iconName: string = button === 'reject' ? 'block' : button;

      return (
        <button
          disabled={numberOfCheckedItems < 1}
          key={iconName}
          className={'multi-select-button ' + button}
          onClick={_ => openConfirmModal(button)}
        >
          <Icon name={iconName} className={'button-icon ' + button + '-icon'} />
          {button}
        </button>
      );
    });
  }, [buttons]);

  return (
    <div className={'dashboard-filter dashboard-multi-select'}>
      <span className={'selected-text'}>{`${numberOfCheckedItems} of ${
        numberOfItems || counts[pageInfo.folder]
      } selected`}</span>
      <span className={'selected-link'} onClick={selectAll}>
        Select all
      </span>
      <span className={'selected-link'} onClick={clearAll}>
        Clear selection
      </span>
      <div className={'buttons'}> {actionButtons} </div>
    </div>
  );
};

export default MultiSelect;
